var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',_vm._b({attrs:{"value":_vm.localValue},on:{"input":_vm.handleInput,"change":_vm.handleInput,"update:search-input":_vm.handleInput}},'v-combobox',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }